import { Component } from '@angular/core';

@Component({
  selector: 'wpro-spinner-small',
  templateUrl: './spinner-small.component.html',
  standalone: false
})
export class SpinnerSmallComponent {

  constructor() { }
}
